// import React, { useState, useContext, useEffect } from "react";
// import "./Home.scss";
// import { FaWhatsapp, FaTelegramPlane } from "react-icons/fa";
// import { NavLink, useLocation, useNavigate } from "react-router-dom";
// import axios from "axios";
// import APP_BASE_URL from "../../components/Api/globalApi";
// import { CiCircleRemove } from "react-icons/ci";
// import { userContext } from "../../context/Auth";
// import moment from "moment";
// import { Button, Form, Modal, ProgressBar } from "react-bootstrap";
// import { useForm } from "react-hook-form";
// import { Table, Spinner } from "react-bootstrap";

// const Home = () => {
//   const { register, handleSubmit, watch, reset, setValue, formState: { errors }, show, onHide } = useForm();
//   const { user } = useContext(userContext);
//   const [showMessage, setShowMessage] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState(0);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [Upgrade, setUpgrade] = useState(null);
//   const [uploadModel, setUploadModel] = useState(false);
//   const [likeCount, setLikeCount] = useState("");
//   const [adsId, setAdsId] = useState();
//   const [FirstFirstPurchase, setFirstPurchase] = useState(null);
//   const today = moment().format("YYYY-MM-DD");
//   const [orderStatus, setOrderStatus] = useState(null);
//   const [showVideo, setShowVideo] = useState(false);
//   const [image, setImage] = useState("");
//   const [showModal, setShowModal] = useState(false);
//   const [districts, setDistricts] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [selectedDistrict, setSelectedDistrict] = useState(""); // Selected district
//   const [successMessage, setSuccessMessage] = useState("");

//   useEffect(() => {
//     if (location.state?.showVideo) {
//       setShowVideo(true);
//       setTimeout(() => {
//         setShowVideo(false);
//       }, 30000);
//     }
//   }, [location.state]);

//   useEffect(() => {
//     const storedDate = localStorage.getItem("user_upgrade_date");

//     if (storedDate && storedDate !== "null") {
//       const upgradeTime = moment(storedDate).format("DD - MMM - YYYY");
//       setUpgrade(`You have upgrade next ${upgradeTime}`);
//     } else {
//       setUpgrade("Upgrade with in 28 days");
//     }

//   }, []);

//   const handleJoinWhatsapp = async () => {
//     setLoading(true);
//     setErrorMessage("");
//     setShowModal(true);

//     try {
//       const response = await axios.post(
//         "https://api.springwayhub.com/mlm/whatsapp-group/list",
//         {}
//       );

//       if (response?.data?.data?.length > 0) {
//         setDistricts(response.data.data);
//       } else {
//         setErrorMessage("No WhatsApp groups available right now.");
//         setDistricts([]);
//       }
//     } catch (error) {
//       console.error("Error fetching WhatsApp groups:", error);
//       setErrorMessage("Failed to fetch groups. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Click group → open link
//   const handleOpenGroup = (group) => {
//     if (group) {
//       window.open(group, "_blank");
//     } else {
//       alert("No WhatsApp group link found for this district.");
//     }
//   };

//   const handleCloseModal = () => {
//     setUploadModel(false);
//   };
//   // Load data from location.state or fallback to localStorage
//   const [data, setData] = useState(
//     location.state?.data || JSON.parse(localStorage.getItem("data")) || {}
//   );
//   const [userStatus, setUserStatus] = useState(
//     localStorage.getItem("userStatus") || "Inactive"
//   );

//   useEffect(() => {
//     if (location.state?.data) {
//       localStorage.setItem("data", JSON.stringify(location.state.data));
//       setData(location.state.data);
//     }
//   }, [location.state]);

//   useEffect(() => {
//     if (user?.data?.user_status) {
//       localStorage.setItem("userStatus", user.data.user_status);
//       setUserStatus(user.data.user_status);
//     }
//   }, [user]);


//   // api call
//   const purchase = async () => {
//     try {
//       const response = await axios.post(
//         `${APP_BASE_URL}/user/home`, {},
//         {
//           headers: {
//             user_id: data.user_id
//           }
//         }
//       );
//       if (response.data.result) {
//         console.log(response?.data?.order_status, "response?.data?.order_status");
//         if (response?.data?.order_status) {
//           let split = response?.data?.order_status.split(',')
//           let leng = split.length - 1
//           setOrderStatus(split[leng]);
//         }
//         if (response.data.purchase_status) {
//           setFirstPurchase(response?.data?.user_first_purchase);
//           console.log(FirstFirstPurchase, orderStatus, 'FirstFirstPurchase')
//         }
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   }
//   useEffect(() => {
//     purchase();
//   }, []);

//   const getReferralId = () => {
//     setShowMessage(true);
//   };

//   const checkStatus = async () => {
//     try {
//       const response = await axios.get(
//         `${APP_BASE_URL}/check/status`,
//         {
//           headers: {
//             user_id: data.user_id,
//             api_key: data.user_api_key,
//           },
//         }
//       );
//       navigate("/my_profile", {
//         state: { data: data, status: response.data },
//       });
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const moveToMyTeam = () => {
//     navigate("/my_team", { state: { data: data } });
//   };

//   const moveToIncome = () => {
//     navigate("/my_income", {
//       state: { data: data, API: data.user_referral_id },
//     });
//   };
//   const moveToIncomenew = () => {
//     navigate("/my_inco", {
//       state: { data: data, API: data.user_referral_id },
//     });
//   };
//   const moveToTransfer = () => {
//     navigate("/Activepass_secure", {
//       // state: { data: data, API: data.user_referral_id },
//     });
//   };
//   const moveToRank = () => {
//     // Ensuring that userRank is safely passed and data is stored locally
//     navigate("/my_rank", {
//       state: { data: data, userRank: user?.data?.user_rank || "" },
//     });
//   };

//   // advertisement
//   const moveToAdvertisement = () => {
//     // Ensuring that userRank is safely passed and data is stored locally
//     navigate("/my_ads", {
//       state: { data: data },//, userRank: user?.data?.user_rank || ""
//     });
//   };

//   const moveToStatus = () => {
//     // Ensuring that userRank is safely passed and data is stored locally
//     navigate("/my_status", {
//       state: { data: data },//, userRank: user?.data?.user_rank || ""
//     });
//   };
//   const onSubmit = async (formDataValues) => {
//     if (isSubmitting) return; // prevent double call
//     setIsSubmitting(true);
//     setUploadProgress(0);

//     try {
//       const file = formDataValues.image?.[0];
//       if (!file) {
//         alert("Please select a valid image file");
//         setIsSubmitting(false);
//         return;
//       }
//       console.log("FormData before file:", file);

//       const formData = new FormData();
//       formData.append("image", file);
//       formData.append("views", formDataValues.views);
//       formData.append("phone_number", formDataValues.phone_number);
//       formData.append("a_id", 0);

//       console.log("FormData before upload:", formData);
//       for (let [key, value] of formData.entries()) {
//         console.log(key, value, '4567890-0oiuhg');
//       }

//       const response = await axios.post(
//         `${APP_BASE_URL}/vitual_mall/upload`,
//         formData,
//         {
//           headers: {
//             user_id: localStorage.getItem("user_id"),
//             "Content-Type": "multipart/form-data",
//           },
//           onUploadProgress: (progressEvent) => {
//             const percent = Math.round(
//               (progressEvent.loaded * 100) / progressEvent.total
//             );
//             setUploadProgress(percent);
//           },
//         }
//       );

//       if (response?.data?.result) {
//         alert("Advertisement added successfully");
//         reset();
//         setUploadProgress(0);
//         onHide();
//       }else if (response?.data?.result === false) {
//         alert(response?.data?.message);
//       } 
//       else {
//         alert("Error when adding advertisement");
//       }
//     } catch (error) {
//       console.error("Upload error:", error);
//       alert(error);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };
//   // Success feedback
//   // Sample district list
//   // useEffect(() => {
//   //   const fetchDistricts = async () => {
//   //     try {
//   //       const response = await axios.post(
//   //         "https://api.springwayhub.com/mlm/whatsapp-group/list",
//   //         {} // Replace with your API for fetching districts
//   //       );
//   //       setDistricts(response.data.data); // Assuming the API returns an array of districts
//   //     } catch (error) {
//   //       console.error("Error fetching districts:", error);
//   //       setErrorMessage("Failed to fetch districts. Please try again later.");
//   //     }
//   //   };

//   //   fetchDistricts();
//   // }, []);
//   const user_dis = localStorage.getItem("user_dis");

//   const handleSubmitnew = async () => {
//     // if (!selectedDistrict) {
//     //   alert("Please select a district!");
//     //   return;
//     // }

//     setLoading(true);
//     setSuccessMessage("");

//     try {
//       // Send the selected district to the endpoint
//       const response = await axios.post(
//         `${APP_BASE_URL}/user/district/whatsapp-group`,
//         { district: user_dis }
//       );

//       if (response.status === 200 && response.data.result) {
//         const groupData = response.data.data[0];
//         if (groupData.wg_group) {
//           window.open(groupData.wg_group, "_blank"); // Open WhatsApp group link in a new tab
//           setSuccessMessage(
//             `Successfully joined the ${selectedDistrict} WhatsApp group!`
//           );
//         } else {
//           alert("No WhatsApp group link found for the selected district.");
//         }
//       } else {
//         alert("Failed to join the group. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error joining the WhatsApp group:", error);
//       alert("An error occurred. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const styles = {
//     overlay: {
//       position: "fixed",
//       top: 0,
//       left: 0,
//       height: "100vh",
//       width: "100vw",
//       backgroundColor: "rgba(0, 0, 0, 0.9)",
//       zIndex: 9999,
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       flexDirection: "column",
//     },
//     videoWrapper: {
//       textAlign: "center",
//     },
//     skipButton: {
//       marginTop: "20px",
//       padding: "10px 20px",
//       fontSize: "16px",
//       backgroundColor: "#fff",
//       color: "#000",
//       border: "none",
//       borderRadius: "5px",
//       cursor: "pointer",
//     },
//   };



//   return (
//     <div className="container-fluid home">
//       <div className="home-details">
//         {/* {Upgrade !== null( */}
//         <div
//           className="profile-linkss"
//           style={{ display: "flex", gap: "20px", alignItems: "center" }}
//         >
//           {/* <h3 className="social text-capitalize" style={{ fontSize: "16px" }}>
//             {Upgrade}
//           </h3> */}
//           {FirstFirstPurchase && (
//             <h3 className="social text-capitalize" style={{ fontSize: "16px" }}>
//               {FirstFirstPurchase}
//             </h3>
//           )}
//           {orderStatus && (<div className="scrolling-container">
//             <div className="scrolling-content">
//               <h3 className="social text-capitalize" style={{ fontSize: "16px" }}>
//                 {orderStatus}
//               </h3>
//             </div>
//           </div>
//           )}
//         </div>

//         {/* ) : null} */}
//         <h3>HIBAWORLD OPC PRIVATE LIMITED</h3>
//         <div className="active">
//           <h4 className="zero-class">
//             {userStatus === "active" ? "Active" : "Inactive"}
//           </h4>
//         </div>
//         <div className="social-medias">
//           <div className="social socialsd">
//             <FaWhatsapp size={30} />
//             <button onClick={handleJoinWhatsapp} style={{ color: "white" }}>
//               <span>Join</span> WhatsApp
//             </button>
//           </div>
//         </div>

//         <Modal
//           show={showModal}
//           onHide={() => setShowModal(false)}
//           centered
//           size="lg"
//           className="whatsapp-group-modal"
//         >
//           <Modal.Header closeButton className="bg-success text-white">
//             <Modal.Title>
//               <FaWhatsapp className="me-2" />
//               Join WhatsApp Group
//             </Modal.Title>
//           </Modal.Header>

//           <Modal.Body className="p-0">
//             {loading ? (
//               <div className="text-center my-5 py-4">
//                 <Spinner animation="border" variant="success" />
//                 <p className="mt-2 text-muted">Loading WhatsApp groups...</p>
//               </div>
//             ) : errorMessage ? (
//               <div className="alert alert-danger text-center m-3">
//                 <CiCircleRemove size={24} className="me-2" />
//                 {errorMessage}
//               </div>
//             ) : districts.length > 0 ? (
//               <div className="groups-list-container">
//                 <div className="p-3 bg-light border-bottom">
//                   <h6 className="mb-0 text-dark">
//                     Available Groups ({districts.length})
//                   </h6>
//                   <small className="text-muted">
//                     Select your district to join the WhatsApp group
//                   </small>
//                 </div>

//                 <div className="groups-scrollable">
//                   {districts.map((group, index) => (
//                     <div key={index} className="group-item border-bottom">
//                       <div className="d-flex justify-content-between align-items-center p-3">
//                         <div className="group-info">
//                           <h6 className="mb-1 fw-bold text-dark">
//                             {group.wg_district_name}
//                           </h6>
//                           <small className="text-muted">
//                             District WhatsApp Group
//                           </small>
//                         </div>
//                         <Button
//                           variant="success"
//                           size="sm"
//                           className="join-btn"
//                           onClick={() => handleOpenGroup(group.wg_group)}
//                         >
//                           <FaWhatsapp className="me-1" />
//                           Join
//                         </Button>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             ) : (
//               <div className="text-center my-5 py-4">
//                 <CiCircleRemove size={48} className="text-muted mb-2" />
//                 <p className="text-muted">No WhatsApp groups available at the moment</p>
//               </div>
//             )}
//           </Modal.Body>

//           <Modal.Footer className="bg-light">
//             <Button
//               variant="outline-secondary"
//               onClick={() => setShowModal(false)}
//             >
//               Close
//             </Button>
//             <small className="text-muted mx-2">
//               You'll be redirected to WhatsApp
//             </small>
//           </Modal.Footer>
//         </Modal>



//         {/* <Modal show={showModal} onHide={() => setShowModal(false)} centered>
//           <Modal.Header closeButton>
//             <Modal.Title style={{ color: "white" }}>
//               Select Your District
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <Form>
//               <Form.Group>
//                 <Form.Label>Choose District</Form.Label>
//                 <Form.Control
//                   as="select"
//                   value={selectedDistrict}
//                   onChange={(e) => setSelectedDistrict(e.target.value)}
//                 >
//                   <option value="">-- Select District --</option>
//                   {districts.map((district, index) => (
//                     <option key={district.id} value={district.wg_district}>
//                       {district.wg_district}
//                     </option>
//                   ))}
//                 </Form.Control>
//               </Form.Group>
//             </Form>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button variant="secondary" onClick={() => setShowModal(false)}>
//               Cancel
//             </Button>
//             <Button variant="success" onClick={handleSubmit} disabled={loading}>
//               {loading ? "Joining..." : "Join Group"}
//             </Button>
//           </Modal.Footer>
//         </Modal> */}

//         {/* Success Message */}
//         {/* {successMessage && (
//           <div className="mt-3 alert alert-success">
//             <strong>{successMessage}</strong>
//           </div>
//         )} */}
//         <div className="profile-links">
//           <div className="social" onClick={checkStatus}>
//             My Profile
//           </div>

//           <div className="social" onClick={moveToMyTeam}>
//             My Team
//           </div>
//           {/* <div className="social" onClick={moveToIncome}>
//             My Vault
//           </div> */}

//           <div className="social" onClick={moveToIncomenew}>
//             My Income
//           </div>

//           {/* <div className="social" onClick={moveToTransfer}>
//             Transfer
//           </div> */}
//           <div className="social" onClick={moveToRank}>
//             My Rank
//           </div>
//           <div className="social" onClick={moveToAdvertisement}>
//             Virtual Mall
//           </div>
//           <div className="social" onClick={moveToStatus}>
//             Status
//           </div>
//           <div className="social" onClick={() => {
//             setUploadModel(true)
//             setAdsId()
//             setLikeCount()
//           }}>
//             Uploads
//           </div>
//           <NavLink to="/my-products" style={{ cursor: "pointer" }}>
//             <div className="social">My Product</div>
//           </NavLink>
//           <NavLink
//             to="#!"
//             style={{
//               PointerEvent: "none",
//               opacity: "0.5",
//               cursor: "not-allowed",
//             }}
//           >
//             <div className="social">Today Achievers</div>
//           </NavLink>
//           <NavLink
//             to="/MyProject"
//           // style={{
//           //   PointerEvent: "none",
//           //   opacity: "0.5",
//           //   cursor: "not-allowed",
//           // }}
//           >
//             <div className="social">My Project</div>
//           </NavLink>
//           <NavLink
//             to="/change_password"
//           // style={{
//           //   PointerEvent: "none",
//           //   opacity: "0.5",
//           //   cursor: "not-allowed",
//           // }}
//           >
//             <div className="social">Change Password</div>
//           </NavLink>
//           <div className="social" onClick={getReferralId}>
//             Referral Link
//           </div>
//         </div>
//       </div>
//       <Modal
//         show={uploadModel}
//         onHide={handleCloseModal}
//         centered
//         backdrop="static" // Prevents closing when clicking outside
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Add Advertisement</Modal.Title> {/* Added title for clarity */}
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
//             {/* IMAGE UPLOAD */}
//             <Form.Group controlId="image">
//               <Form.Label>Add Advertisement</Form.Label>
//               <Form.Control
//                 type="file"
//                 accept="image/*"
//                 {...register("image", {
//                   required: "Please select an image file",
//                   validate: {
//                     isImage: (value) =>
//                       value?.[0]?.type?.startsWith("image/") ||
//                       "Only image files are allowed",
//                   },
//                 })}
//                 isInvalid={!!errors.image}
//               />
//               <Form.Control.Feedback type="invalid">
//                 {errors.image?.message}
//               </Form.Control.Feedback>
//             </Form.Group>

//             {/* VIEWS COUNT */}
//             <Form.Group controlId="views" className="mt-3">
//               <Form.Label>Views Count</Form.Label>
//               <Form.Control
//                 type="number"
//                 placeholder="Enter Views Count"
//                 {...register("views", { required: "Views count is required" })}
//                 isInvalid={!!errors.views}
//               />
//               <Form.Control.Feedback type="invalid">
//                 {errors.views?.message}
//               </Form.Control.Feedback>
//             </Form.Group>

//             {/* PHONE NUMBER */}
//             {/* <Form.Group controlId="phone_number" className="mt-3">
//               <Form.Label>Phone Number</Form.Label>
//               <Form.Control
//                 type="tel"
//                 placeholder="Enter phone number"
//                 {...register("phone_number", {
//                   required: "Phone number is required",
//                   pattern: {
//                     value: /^[0-9]{10}$/,
//                     message: "Phone number must be 10 digits",
//                   },
//                 })}
//                 isInvalid={!!errors.phone_number}
//               />
//               <Form.Control.Feedback type="invalid">
//                 {errors.phone_number?.message}
//               </Form.Control.Feedback>
//             </Form.Group> */}

//             {/* UPLOAD PROGRESS */}
//             {isSubmitting && (
//               <div className="mt-3">
//                 <ProgressBar now={uploadProgress} label={`${uploadProgress}%`} />
//               </div>
//             )}

//             {/* SUBMIT BUTTON */}
//             <Button
//               variant="primary"
//               type="submit"
//               className="mt-3 w-100"
//               style={{
//                 padding: "10px",
//                 fontSize: "1.1rem",
//                 fontWeight: "bold",
//                 backgroundColor: "#0d6efd",
//                 color: "#fff",
//                 border: "none",
//               }}
//               disabled={isSubmitting}
//             >
//               {isSubmitting ? (
//                 <>
//                   <span
//                     className="spinner-border spinner-border-sm me-2"
//                     role="status"
//                     aria-hidden="true"
//                   ></span>
//                   Uploading...
//                 </>
//               ) : (
//                 "Upload"
//               )}
//             </Button>
//           </Form>

//         </Modal.Body>
//       </Modal>
//       {showMessage && (
//         <div className="success-message">
//           <CiCircleRemove
//             size={30}
//             color="black"
//             className="close-icon"
//             onClick={() => setShowMessage(false)}
//             style={{ position: "absolute", right: "20px", top: "5px" }}
//           />
//           <h6>
//             https://www.springwayhub.com/register/?referral_id=
//             {data.user_referral_id}
//           </h6>
//         </div>
//       )}

//       {showVideo && (
//         <div style={styles.overlay}>
//           <div style={styles.videoWrapper}>
//             <iframe
//               width="720"
//               height="405"
//               src="https://www.youtube.com/embed/OBw63mqdC5Y?autoplay=1"
//               title="Login Video"
//               frameBorder="0"
//               allow="autoplay; encrypted-media"
//               allowFullScreen
//             ></iframe>
//             <button onClick={() => setShowVideo(false)} style={styles.skipButton}>
//               Skip
//             </button>
//           </div>
//         </div>
//       )}

//       {/* {showVideo && (
//         <button onClick={() => setShowVideo(false)} style={{ marginTop: "10px" }}>
//           Skip Video
//         </button>
//       )} */}

//     </div>
//   );
// };

// export default Home;


import React, { useState, useContext, useEffect } from "react";
import "./Home.scss";
import { FaWhatsapp, FaTelegramPlane } from "react-icons/fa";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import APP_BASE_URL from "../../components/Api/globalApi";
import { CiCircleRemove } from "react-icons/ci";
import { userContext } from "../../context/Auth";
import moment from "moment";
import { Button, Form, Modal, ProgressBar } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Table, Spinner } from "react-bootstrap";
import { X } from "lucide-react";

const Home = () => {
  // Fixed: Removed onHide and show from useForm destructuring
  const { register, handleSubmit, reset, formState: { errors } } = useForm();

  const { user } = useContext(userContext);
  const [showMessage, setShowMessage] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [Upgrade, setUpgrade] = useState(null);
  const [uploadModel, setUploadModel] = useState(false);
  const [likeCount, setLikeCount] = useState("");
  const [adsId, setAdsId] = useState();
  const [FirstFirstPurchase, setFirstPurchase] = useState(null);
  const today = moment().format("YYYY-MM-DD");
  const [orderStatus, setOrderStatus] = useState(null);
  const [showVideo, setShowVideo] = useState(false);
  const [image, setImage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    if (location.state?.showVideo) {
      setShowVideo(true);
      setTimeout(() => {
        setShowVideo(false);
      }, 30000);
    }
  }, [location.state]);

  useEffect(() => {
    const storedDate = localStorage.getItem("user_upgrade_date");

    if (storedDate && storedDate !== "null") {
      const upgradeTime = moment(storedDate).format("DD - MMM - YYYY");
      setUpgrade(`You have upgrade next ${upgradeTime}`);
    } else {
      setUpgrade("Upgrade with in 28 days");
    }
  }, []);

  // Intercept back button
  useEffect(() => {
    // Push an extra entry into history to intercept the back button
    window.history.pushState(null, null, window.location.pathname);

    const handlePopState = (event) => {
      // When back is pressed, push the state again to stay on current page and show modal
      window.history.pushState(null, null, window.location.pathname);
      setShowLogoutModal(true);
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  const logOut = async () => {
    try {
      const response = await axios.post(
        `${APP_BASE_URL}/user/logout`,
        {},
        {
          headers: {
            user_id: data.user_id,
            api_key: data.user_api_key,
          },
        }
      );
      if (response.data.result === true) {
        localStorage.clear();
        navigate("/");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleJoinWhatsapp = async () => {
    setLoading(true);
    setErrorMessage("");
    setShowModal(true);

    try {
      const response = await axios.post(
        "https://api.springwayhub.com/mlm/whatsapp-group/list",
        {}
      );

      if (response?.data?.data?.length > 0) {
        setDistricts(response.data.data);
      } else {
        setErrorMessage("No WhatsApp groups available right now.");
        setDistricts([]);
      }
    } catch (error) {
      console.error("Error fetching WhatsApp groups:", error);
      setErrorMessage("Failed to fetch groups. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenGroup = (group) => {
    if (group) {
      window.open(group, "_blank");
    } else {
      alert("No WhatsApp group link found for this district.");
    }
  };

  const handleCloseModal = () => {
    setUploadModel(false);
  };

  const [data, setData] = useState(
    location.state?.data || JSON.parse(localStorage.getItem("data")) || {}
  );
  const [userStatus, setUserStatus] = useState(
    localStorage.getItem("userStatus") || "Inactive"
  );

  useEffect(() => {
    if (location.state?.data) {
      localStorage.setItem("data", JSON.stringify(location.state.data));
      setData(location.state.data);
    }
  }, [location.state]);

  useEffect(() => {
    if (user?.data?.user_status) {
      localStorage.setItem("userStatus", user.data.user_status);
      setUserStatus(user.data.user_status);
    }
  }, [user]);

  const purchase = async () => {
    try {
      const response = await axios.post(
        `${APP_BASE_URL}/user/home`, {},
        {
          headers: {
            user_id: data.user_id
          }
        }
      );
      if (response.data.result) {
        if (response?.data?.order_status) {
          let split = response?.data?.order_status.split(',')
          let leng = split.length - 1
          setOrderStatus(split[leng]);
        }
        if (response.data.purchase_status) {
          setFirstPurchase(response?.data?.user_first_purchase);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    purchase();
  }, []);

  const getReferralId = () => {
    setShowMessage(true);
  };

  const checkStatus = async () => {
    try {
      const response = await axios.get(
        `${APP_BASE_URL}/check/status`,
        {
          headers: {
            user_id: data.user_id,
            api_key: data.user_api_key,
          },
        }
      );
      navigate("/my_profile", {
        state: { data: data, status: response.data },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const moveToMyTeam = () => {
    navigate("/my_team", { state: { data: data } });
  };

  const moveToIncome = () => {
    navigate("/my_income", {
      state: { data: data, API: data.user_referral_id },
    });
  };

  const moveToIncomenew = () => {
    navigate("/my_inco", {
      state: { data: data, API: data.user_referral_id },
    });
  };

  const moveToTransfer = () => {
    navigate("/Activepass_secure", {});
  };

  const moveToRank = () => {
    navigate("/my_rank", {
      state: { data: data, userRank: user?.data?.user_rank || "" },
    });
  };

  const moveToAdvertisement = () => {
    navigate("/my_ads", {
      state: { data: data },
    });
  };

  const moveToStatus = () => {
    navigate("/my_status", {
      state: { data: data },
    });
  };

  // Fixed onSubmit function
  const onSubmit = async (formDataValues) => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    setUploadProgress(0);

    try {
      const file = formDataValues.image?.[0];
      if (!file) {
        alert("Please select a valid image file");
        setIsSubmitting(false);
        return;
      }

      const formData = new FormData();
      formData.append("image", file);
      formData.append("views", formDataValues.views);
      formData.append("phone_number", formDataValues.phone_number || "");
      formData.append("a_id", 0);

      const response = await axios.post(
        `${APP_BASE_URL}/vitual_mall/upload`,
        formData,
        {
          headers: {
            user_id: localStorage.getItem("user_id"),
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percent);
          },
        }
      );

      if (response?.data?.result) {
        alert("Advertisement added successfully");
        setTimeout(() => {
          reset();
          setUploadProgress(0);
          setUploadModel(false); // Fixed: Changed from onHide() to setUploadModel(false)
        }, 100);
      } else if (response?.data?.result === false) {
        alert(response?.data?.message);
        setUploadModel(false); // Close modal on error
      } else {
        alert("Error when adding advertisement");
        setUploadModel(false); // Close modal on error
      }
    } catch (error) {
      console.error("Upload error:", error);
      alert("Upload failed. Please try again.");
      setUploadModel(false); // Close modal on error
    } finally {
      setIsSubmitting(false);
    }
  };

  const user_dis = localStorage.getItem("user_dis");

  const handleSubmitnew = async () => {
    setLoading(true);
    setSuccessMessage("");

    try {
      const response = await axios.post(
        `${APP_BASE_URL}/user/district/whatsapp-group`,
        { district: user_dis }
      );

      if (response.status === 200 && response.data.result) {
        const groupData = response.data.data[0];
        if (groupData.wg_group) {
          window.open(groupData.wg_group, "_blank");
          setSuccessMessage(
            `Successfully joined the ${selectedDistrict} WhatsApp group!`
          );
        } else {
          alert("No WhatsApp group link found for the selected district.");
        }
      } else {
        alert("Failed to join the group. Please try again.");
      }
    } catch (error) {
      console.error("Error joining the WhatsApp group:", error);
      alert("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      height: "100vh",
      width: "100vw",
      backgroundColor: "rgba(0, 0, 0, 0.9)",
      zIndex: 9999,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
    },
    videoWrapper: {
      textAlign: "center",
    },
    skipButton: {
      marginTop: "20px",
      padding: "10px 20px",
      fontSize: "16px",
      backgroundColor: "#fff",
      color: "#000",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
    },
  };

  return (
    <div className="container-fluid home">
      <div className="home-details">
        <div
          className="profile-linkss"
          style={{ display: "flex", gap: "20px", alignItems: "center" }}
        >
          {FirstFirstPurchase && (
            <h3 className="social text-capitalize" style={{ fontSize: "16px" }}>
              {FirstFirstPurchase}
            </h3>
          )}
          {orderStatus && (
            <div className="scrolling-container">
              <div className="scrolling-content">
                <h3 className="social text-capitalize" style={{ fontSize: "16px" }}>
                  {orderStatus}
                </h3>
              </div>
            </div>
          )}
        </div>

        <h3>HIBAWORLD OPC PRIVATE LIMITED</h3>
        <div className="active">
          <h4 className="zero-class">
            {userStatus === "active" ? "Active" : "Inactive"}
          </h4>
        </div>
        <div className="social-medias">
          <div className="social socialsd">
            <FaWhatsapp size={30} />
            <button onClick={handleJoinWhatsapp} style={{ color: "white" }}>
              <span>Join</span> WhatsApp
            </button>
          </div>
        </div>

        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
          size="lg"
          className="whatsapp-group-modal"
        >
          <Modal.Header closeButton className="bg-success text-white">
            <Modal.Title>
              <FaWhatsapp className="me-2" />
              Join WhatsApp Group
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="p-0">
            {loading ? (
              <div className="text-center my-5 py-4">
                <Spinner animation="border" variant="success" />
                <p className="mt-2 text-muted">Loading WhatsApp groups...</p>
              </div>
            ) : errorMessage ? (
              <div className="alert alert-danger text-center m-3">
                <CiCircleRemove size={24} className="me-2" />
                {errorMessage}
              </div>
            ) : districts.length > 0 ? (
              <div className="groups-list-container">
                <div className="p-3 bg-light border-bottom">
                  <h6 className="mb-0 text-dark">
                    Available Groups ({districts.length})
                  </h6>
                  <small className="text-muted">
                    Select your district to join the WhatsApp group
                  </small>
                </div>

                <div className="groups-scrollable">
                  {districts.map((group, index) => (
                    <div key={index} className="group-item border-bottom">
                      <div className="d-flex justify-content-between align-items-center p-3">
                        <div className="group-info">
                          <h6 className="mb-1 fw-bold text-dark">
                            {group.wg_district_name}
                          </h6>
                          <small className="text-muted">
                            District WhatsApp Group
                          </small>
                        </div>
                        <Button
                          variant="success"
                          size="sm"
                          className="join-btn"
                          onClick={() => handleOpenGroup(group.wg_group)}
                        >
                          <FaWhatsapp className="me-1" />
                          Join
                        </Button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className="text-center my-5 py-4">
                <CiCircleRemove size={48} className="text-muted mb-2" />
                <p className="text-muted">No WhatsApp groups available at the moment</p>
              </div>
            )}
          </Modal.Body>

          <Modal.Footer className="bg-light">
            <Button
              variant="outline-secondary"
              onClick={() => setShowModal(false)}
            >
              Close
            </Button>
            <small className="text-muted mx-2">
              You'll be redirected to WhatsApp
            </small>
          </Modal.Footer>
        </Modal>

        <div className="profile-links">
          <div className="social" onClick={checkStatus}>
            My Profile
          </div>

          <div className="social" onClick={moveToMyTeam}>
            My Team
          </div>

          <div className="social" onClick={moveToIncomenew}>
            My Income
          </div>

          <div className="social" onClick={moveToRank}>
            My Rank
          </div>
          <div className="social" onClick={moveToAdvertisement}>
            Virtual Mall
          </div>
          <div className="social" onClick={moveToStatus}>
            Status
          </div>
          <div className="social" onClick={() => {
            setUploadModel(true)
            setAdsId()
            setLikeCount()
          }}>
            Uploads
          </div>
          <NavLink to="/my-products" style={{ cursor: "pointer" }}>
            <div className="social">My Product</div>
          </NavLink>
          <NavLink
            to="#!"
            style={{
              PointerEvent: "none",
              opacity: "0.5",
              cursor: "not-allowed",
            }}
          >
            <div className="social">Today Achievers</div>
          </NavLink>
          <NavLink to="/MyProject">
            <div className="social">My Project</div>
          </NavLink>
          <NavLink to="/change_password">
            <div className="social">Change Password</div>
          </NavLink>
          <div className="social" onClick={getReferralId}>
            Referral Link
          </div>
        </div>
      </div>

      <Modal
        show={uploadModel}
        onHide={handleCloseModal}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Advertisement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
            <Form.Group controlId="image">
              <Form.Label>Add Advertisement</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                {...register("image", {
                  required: "Please select an image file",
                  validate: {
                    isImage: (value) =>
                      value?.[0]?.type?.startsWith("image/") ||
                      "Only image files are allowed",
                  },
                })}
                isInvalid={!!errors.image}
              />
              <Form.Control.Feedback type="invalid">
                {errors.image?.message}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="views" className="mt-3">
              <Form.Label>Views Count</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter Views Count"
                {...register("views", { required: "Views count is required" })}
                isInvalid={!!errors.views}
              />
              <Form.Control.Feedback type="invalid">
                {errors.views?.message}
              </Form.Control.Feedback>
            </Form.Group>

            {isSubmitting && (
              <div className="mt-3">
                <ProgressBar now={uploadProgress} label={`${uploadProgress}%`} />
              </div>
            )}

            <Button
              variant="primary"
              type="submit"
              className="mt-3 w-100"
              style={{
                padding: "10px",
                fontSize: "1.1rem",
                fontWeight: "bold",
                backgroundColor: "#0d6efd",
                color: "#fff",
                border: "none",
              }}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Uploading...
                </>
              ) : (
                "Upload"
              )}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {showMessage && (
        <div className="success-message">
          <CiCircleRemove
            size={30}
            color="black"
            className="close-icon"
            onClick={() => setShowMessage(false)}
            style={{ position: "absolute", right: "20px", top: "5px" }}
          />
          <h6>
            https://www.springwayhub.com/register/?referral_id=
            {data.user_referral_id}
          </h6>
        </div>
      )}

      {showVideo && (
        <div style={styles.overlay}>
          <div style={styles.videoWrapper}>
            <iframe
              width="720"
              height="405"
              src="https://www.youtube.com/embed/OBw63mqdC5Y?autoplay=1"
              title="Login Video"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
            ></iframe>
            <button onClick={() => setShowVideo(false)} style={styles.skipButton}>
              Skip
            </button>
          </div>
        </div>
      )}

      {/* Logout Confirmation Modal */}
      {showLogoutModal && (
        <div className="vm-modal-overlay" onClick={() => setShowLogoutModal(false)}>
          <div className="vm-modal-content logout-modal" onClick={(e) => e.stopPropagation()}>
            <div className="vm-modal-header">
              <h2>Confirm Logout</h2>
              <button className="vm-modal-close" onClick={() => setShowLogoutModal(false)}>
                <X size={24} />
              </button>
            </div>
            <div className="vm-modal-body">
              <div className="logout-warning">
                <span className="warning-icon">⚠️</span>
                <p>Are you sure you want to logout?</p>
              </div>
              <div className="vm-modal-actions">
                <button
                  className="primary-btn logout-confirm-btn"
                  onClick={() => {
                    setShowLogoutModal(false);
                    logOut();
                  }}
                >
                  Yes, Logout
                </button>
                <button
                  className="secondary-btn"
                  onClick={() => setShowLogoutModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;